export const optionsForSurvey = () => {
  const queryStringParameters = {}
  const currentRole = readSelectedRole()

  if (currentRole) {
    queryStringParameters.currentRole = currentRole
  }

  return Object.keys(queryStringParameters).length
    ? { queryStringParameters }
    : {}
}

function readSelectedRole() {
  try {
    return localStorage.getItem('puls-selected-role')
  } catch (_) {
    return null
  }
}
